/* eslint-disable no-underscore-dangle */
import React, { useEffect, useState } from "react";
import OwlCarousel from "react-owl-carousel2";
import ErrorMessage from "components/ErrorMessage";
import Query from "components/Query";
import ErrorImage from "components/ErrorImage";
import LazyLoadImage from "components/LazyLoadImage";
import "react-owl-carousel2/lib/styles.css";
import { useHistory } from "react-router-dom";
import useWindowWidth from "components/UseWindowWidth";
// import LazyLoadImage from 'components/LazyLoadImage'

const PhotoOfDay = ({ url }) => {

  const history = useHistory()

  const carouselOptions = {
    items: 5,
    loop: true,
    margin: 5,
    nav: true,
    dots: false,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    navText: [
      '<img src="/img/arrow-button-left.svg" id="custom-prev">',
      '<img src="/img/arrow-button-right.svg" id="custom-next">'
    ],
  };

  const [buttonId, setButtonId] = useState();

  const width = useWindowWidth();

  const handleMouseEnter = (id) => {
    setButtonId(id);
  };

  const handleMouseLeave = () => {
    setButtonId("");
  };

  useEffect(() => {
    const handleResize = () => {
      if (width < 768) {
        // On mobile screens, display 2 items
        carouselOptions.items = 2.5;
      } else if (width > 1800) {
        carouselOptions.items = 5;
      } else {
        // On larger screens (desktop), display 5 items
        carouselOptions.items = 4;
      }
    };

    // Initial setup
    handleResize();

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  console.log("carousel data is", url);

  return (
    // <div className="photo-oftheday-slider-wrapper wow fadeInUp">
    //   <div className="photo-of-flex">
    //   <img className="happy-client-image" src="/img/pink-dot.svg" />
    //   <h4 className="our-happy-clients">Our Happy Clients</h4>
    //   </div>
    //   <Query url={url} error={<ErrorImage />}>
    //     {({ data }) => (
    //       <>
    //         <OwlCarousel
    //           options={carouselOptions}
    //           className="owl-carousel owl-theme photo-oftheday-slider nav-right-top total-outer-wrap"
    //         >
    //           {data.length > 0 &&
    //             data.map(item => (
    //               <div key={item._id} className="item">
    //                 <div className="happy-client-image-list" style={{ position: 'relative' }}>
    //                   <LazyLoadImage
    //                     overlaySrc={`${process.env.REACT_APP_BASE_URL}/${item.image.thumbnail}`}
    //                     src={`${process.env.REACT_APP_BASE_URL}/${item.image.url}`}
    //                     alt={item.title}
    //                   />
    //                   {/* <img
    //                     loading="lazy"
    //                     src={item.image.thumbnail}
    //                     srcSet={item.image.url}
    //                     alt={item.title}
    //                   /> */}
    //                 </div>
    //               </div>
    //             ))}
    //         </OwlCarousel>
    //         {data.length === 0 && <ErrorMessage message="No photos to show" />}
    //       </>
    //     )}
    //   </Query>
    // </div>
    <div>
      <div className="photo-of-flex wow bounceInLeft">
        <img className="happy-client-image" src="/img/pink-dot.svg" />
        <h4 className="our-happy-clients">Happy Patients</h4>
      </div>
      <Query url={url} error={<ErrorImage />}>
        {({ data }) => (
          <>
            <OwlCarousel
              options={carouselOptions}
              className="owl-carousel owl-theme owl-outer wow fadeInUp"
            >
              {data.length > 0 &&
                data.map((item) => (
                  <div>
                    <img
                      className="owl-images"
                      src={`${process.env.REACT_APP_BASE_URL}/${item.image.url}`}
                    />
                  </div>
                ))}
            </OwlCarousel>
            {data.length === 0 && <ErrorMessage message="No photos to show" />}
          </>
        )}
      </Query>
      <div className="photo-day-view-div">
        <button
          onMouseEnter={() => {
            handleMouseEnter("photoblog");
          }}
          onMouseLeave={handleMouseLeave}
          className="photo-day-view"
          onClick={()=>history.push(`/gallery/happy-patients`)}
        >
          View All
          <img src={
                      buttonId == "photoblog"
                        ? "/img/arrow-right-big.svg"
                        : "/img/arrow-right.svg"
                    } />
        </button>
      </div>
    </div>
  );
};

export default PhotoOfDay;
